var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('main-menu'),_vm._v(" "),_c('section',{staticClass:"wrapper scrollable"},[_c('user-menu'),_vm._v(" "),_c('title-bar'),_vm._v(" "),_c('quick-launch'),_vm._v(" "),_c('dashboard-widgets'),_vm._v(" "),_c('section',{staticClass:"widget-group"})],1),_vm._v(" "),_c('assets'),_vm._v(" "),_c('session-modal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }